import React from 'react'

const Media = () => {
  return (
    <div className='padding-top'>Coming Soon</div>
  )
}

export default Media